<template>
    <div>
        <CHeader class="bg-dark position-relative">
            <div class="mt-2"  style="margin: 0 12%;">
                <div style="width:200px !important;">
                    <img block class="w-100 h-100" :src="companyLogo" />
                </div>
            </div>
        </CHeader>
        <div style="margin: 0 12%;">
            <CAlert 
                @update:show="(value)=> alertEvent(value)"
                class="w-50 mx-auto mt-5 fixed-top"
                :color="alert.color" :closeButton="typeof(alert.show)!=='number'" :show.sync="alert.show">
                {{alert.message}}   
                <CProgress
                    v-if="typeof(alert.show)=='number'"
                    :max="5"
                    :value="alert.show"
                    height="3px"
                    :color="alert.color"
                    animate
                    class="my-3"
                />         
            </CAlert>
            <CCard class="mt-5">
                <CCardHeader>
                    <h2>
                        Seguimiento de Pedido
                    </h2>
                    <div>
                      <h3>
                        {{companyName}}
                      </h3>
                      <p>
                        <CIcon name="cil-spreadsheet"/> {{prefix}} - {{number}}
                      </p>
                      <p>
                        <CIcon name="cil-calendar"/> {{date}}
                      </p>
                    </div>
                </CCardHeader>
                <CCardBody class="min-vh-70 w-100">
                    <div ref="map-root" style="width: 100%; height: 70vh"></div>
                </CCardBody>
            </CCard>
        </div>

        <CElementCover v-show="loading"/>
    </div>
</template>
<style scoped>
  #map {
    width: 100%;
  }
</style>

<script>
  import 'ol/ol.css'
  
  import moment from 'moment'
  import Feature from 'ol/Feature'
  import View from 'ol/View'
  import Map from 'ol/Map'
  import Point from 'ol/geom/Point'
  import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer'
  import VectorSource from 'ol/source/Vector'
  import OSM from 'ol/source/OSM'
  import {fromLonLat} from 'ol/proj'
  import {
    Icon,
    Style,
    //Circle as CircleStyle,
    //Fill,
    //Stroke,
  } from 'ol/style'
  import { getCompanyLogo, errorMessage } from "@/general"
  import { dataGeolocalizacionDocumento } from '@/api'

  export default {
    data() {
      return {
        companyLogo: '',
        map: null,
        view: {},
        geoMarker: {},
        companyName: '',
        prefix: '',
        number: '',
        date: '',
        loading: false
      }
    },
    async mounted() {
      const {companyLogo} = await getCompanyLogo()
      this.companyLogo = companyLogo    

      if(!this.$router.currentRoute.query.id){
        this.$store.commit(
            'setAlert',
            { 
            color: 'danger',
            message: 'No se pudo completar la acción',
            show: 5 
            }
        )
        return
      }
      this.mapSetup()
      await this.getData()

      setInterval(
        async () => {
          await this.getData()
        },
        300000
      )
      
    },
    methods: {
      alertEvent(value){
        if (typeof(value) == 'boolean') {    
          this.$store.commit('setAlert',{ show: false })
        } else {      
          if (!value) {
            this.$store.commit('setAlert',{ show: false })
          }
        }
      },
      async getData() {
        try {
          this.loading = true

          const {response} = await dataGeolocalizacionDocumento(this, this.$router.currentRoute.query.id)
          this.date = moment(response[0].Fecha_Emision).format('DD/MM/YYYY')
          this.companyName = response[0].Empresa
          this.number = response[0].Numero
          this.prefix = response[0].Prefijo

          this.view.animate({
            center: fromLonLat([response[0].Longitud, response[0].Latitud]),
            duration: 1000,
          })
          this.geoMarker.setGeometry(new Point(fromLonLat([response[0].Longitud, response[0].Latitud])))
        } catch(error) {
          console.log(error)
          this.$store.commit(
            'setAlert',
            { 
            color: 'danger',
            message: errorMessage(error),
            show: 5 
            }
          )
        } finally {
          this.loading = false
        }
      },
      mapSetup() {
        const styles = {
          'geoMarker': new Style({
            image: new Icon({
              anchor: [0.5, 1],
              src: 'static/icon_car.png',
            }),
          })
        }
        const bogotaLonLat = [-74.063644, 4.624335]
        this.view = new View({
          zoom: 19,
          center: fromLonLat(bogotaLonLat)
        })
        this.map = new Map({
            target: this.$refs['map-root'],
            layers: [
              // adding a background tiled layer
              new TileLayer({
                preload: 4,
                source: new OSM() // tiles are served by OpenStreetMap
              }),
            ],
            // the map view will initially show the whole world
            view: this.view,
        })
        this.geoMarker = new Feature({
          type: 'geoMarker',
          geometry: new Point(fromLonLat(bogotaLonLat)),
        })

        const vectorLayer = new VectorLayer({
          source: new VectorSource({
            features: [this.geoMarker],
          }),
          style: function (feature) {
            return styles[feature.get('type')]
          },
        })
        this.map.addLayer(vectorLayer)
      }
    },
    computed: {
      alert(){
        return this.$store.state.alert
      },
    }
  }
</script>
